import {
  Avatar,
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import Loading from "../../../components/common/Loading";
import { IUserProfile } from "../../../models/admin/user.model";
import userService from "../../../services/user.service";
import { getFullDate } from "../../../utils/classOfDegree";
import Adminroutes from "../routes";
import Pagination from "react-paginate";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronDownIcon,
  HamburgerIcon,
} from "@chakra-ui/icons";

const Users = () => {
  const [loading, setLoading] = useState(true);
  const [allStaff, setAllStaff] = useState<IUserProfile[]>([]);
  const [filteredStaff, setFilteredStaff] = useState<IUserProfile[]>([]);
  const navigate = useNavigate();
  const [user, setUser] = useState<IUserProfile>();
  const [operation, setOperationTypes] = useState("");
  const [isUser, setisUser] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filter_type, setFiltertype] = useState("");
  const [reload, setReload] = useState(false);

  const showLabels = useBreakpointValue({ base: false, md: true });

  useEffect(() => {
    const url = operation === "All" ? `?category=` : `?category=${operation}`;
    userService.getUserByCategory(url).then((res) => {
      setAllStaff(res.data);
      setFilteredStaff(res.data);
      setLoading(false);
    });
  }, [reload, operation]);

  const openEditUser = (param: IUserProfile) => {
    setUser(param);
    navigate(Adminroutes.EditUserLink(param.uuid), {state: param});
    setisUser(true);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredStaff(allStaff);
    } else {
      if (allStaff) {
        const filtered = allStaff.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredStaff(filtered);
      }
    }
  };

  const viewStaff = async (trainee_id: string) => {
    navigate(Adminroutes.ReviewTraineeLink(trainee_id));
  };

  const currentItems = filteredStaff.slice(
    currentPage * perPage,
    (currentPage + 1) * perPage
  );

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  const validOperationTypes = [
    "All",
    "Mis Admin",
    "Director General",
    "Super Admin",
    "Admin",
  ];
  function updateOperation(operation_type: string): void {
    if (validOperationTypes.includes(operation_type)) {
      setOperationTypes(operation_type);
      setFiltertype(operation_type);
      setReload(!reload);
    } else {
      console.error("Unknown operation type");
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Staff
                </Box>
                <HStack>
                  <Button
                    colorScheme="red"
                    p="7px"
                    borderRadius={"2px"}
                    fontSize="14px"
                    onClick={() => navigate(Adminroutes.NewUser)}
                  >
                    Add Staff
                  </Button>
                </HStack>
              </Flex>
              <Flex py="15px" justifyContent="" gap="1rem">
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width={["90%", "90%", "50%", "30%"]}
                >
                  <Input
                    height="40px"
                    placeholder="Search staff by name"
                    onChange={(e) => handleSearchChange(e)}
                    fontSize={12}
                    size="sm"
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
                <Menu>
                  <MenuButton
                    px={6}
                    py={2}
                    transition="all 0.2s"
                    borderRadius="md"
                    borderWidth="1px"
                    backgroundColor="white"
                    color="#616161"
                  >
                    {operation ? operation : "Filter by"}
                    <ChevronDownIcon />
                  </MenuButton>
                  <MenuList>
                    {validOperationTypes.map((operation, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => updateOperation(operation)}
                      >
                        {operation}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Menu>
              </Flex>
              <Box width={"100%"}>
                <TableContainer>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>Full name</Th>
                        <Th>Email</Th>
                        <Th>Category</Th>
                        <Th>Created </Th>
                        <Th>Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {currentItems?.map((each) => (
                        <Tr bg="white" key={each.id}>
                          <Td>
                            <HStack spacing="10px">
                              <Avatar name={each?.name} size="sm" />
                              <Text
                                fontWeight="600"
                                fontSize="16px"
                                color="#616161"
                              >
                                {each.name}
                                <br></br>
                                {/* Mechanical Engineering */}
                              </Text>
                            </HStack>
                          </Td>
                          <Td>
                            <Text>{each.email}</Text>
                          </Td>
                          <Td>
                            {" "}
                            <Text>{each.category}</Text>
                          </Td>

                          <Td>
                            {" "}
                            <Text>{getFullDate(each.created_at)}</Text>
                          </Td>

                          <Td>
                            <HStack>
                              <Center
                                border="1px solid"
                                borderRadius="10px"
                                onClick={() => {
                                  viewStaff(each.uuid);
                                }}
                                borderColor="#E5E5E5"
                                width="30px"
                                height="30px"
                              >
                                <RiEyeLine />
                              </Center>
                              {/* <Center
                                border="1px solid"
                                borderRadius="10px"
                                onClick={() => {
                                  openEditUser(each);
                                }}
                                borderColor="#E5E5E5"
                                width="30px"
                                height="30px"
                              >
                                <BiEdit />
                              </Center> */}
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
                {currentItems.length > 0 && (
                  <Box pb={{ base: "0.5rem", sm: "1rem" }}>
                    <Pagination
                      breakLabel="..."
                      nextLabel={
                        showLabels ? (
                          <ArrowRightIcon style={{ fontSize: 18 }} />
                        ) : null
                      }
                      onPageChange={handlePageChange}
                      pageRangeDisplayed={5}
                      pageCount={Math.ceil(filteredStaff.length / perPage)}
                      previousLabel={
                        showLabels ? (
                          <ArrowLeftIcon style={{ fontSize: 18 }} />
                        ) : null
                      }
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="active"
                      // renderOnZeroPageCount={null}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default Users;
